import React from "react";
import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";
import { AutoComplete, Input } from "antd";
import { useDebounce } from "components/ratecard/hooks";
import { WRO } from "services/BillingEngineService/interfaces/entities/WRO";
import { SearchOutlined } from "@ant-design/icons";
import colors from "css/colors";
import { AutoCompleteProps } from "antd/lib/auto-complete";

interface WROSearchbar extends Omit<AutoCompleteProps, "onSelect"> {
  onSelect: (organization?: WRO) => void;
}

function WROSearchbar({ onSelect, ...rest }: WROSearchbar) {
  const [search, setSearch] = React.useState("");
  const debouncedSearch = useDebounce(search, 500);

  const { data = [] } = useQuery<WRO[], any>(["wros", debouncedSearch], BillingEngineService.getWROs, {
    retry: false,
  });

  const onSearch = (value: string) => {
    setSearch(value || "");

    // onClear
    if (value === "") {
      onSelect(undefined);
    }
  };

  function handleSelect(_: string, option: any) {
    const matchingWRO = data.find((wro) => wro.wroId === option.value);

    if (matchingWRO) {
      onSelect(matchingWRO);
    }
  }

  const options: any[] = data.map((org: WRO) => {
    return {
      label: org.wroId,
      value: org.wroId,
    };
  });

  return (
    <AutoComplete options={options} onSearch={onSearch} onSelect={handleSelect} allowClear {...rest}>
      <Input
        prefix={<SearchOutlined style={{ marginRight: "8px", color: colors.GREY_DARK }} />}
        placeholder="Search WROs"
      />
    </AutoComplete>
  );
}

export default WROSearchbar;
